<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "cashonhandbank-wrapper"
};
</script>

<style>
</style>